import { isOneOfTags } from 'anodum';
import getSupportedTagNames from './get-supported-tag-names';
import addRelatedClassName from './add-related-class-name';

const addRelatedClassesToElement = (element) => {
  if (!element) {
    return null;
  }

  const supportedTags = getSupportedTagNames();
  if (isOneOfTags(element, supportedTags)) {
    addRelatedClassName(element);
  }

  element.querySelectorAll(supportedTags).forEach(addRelatedClassName);

  return element;
};

export default addRelatedClassesToElement;
